import React, { useEffect, useMemo, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg'; // Sorting icon
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import editPenImg from '../../assets/images/CustomerManagement/edit-pen-img.svg';
import SbStatusDropdown from '../Buttons/SbStatusDropdown';
import SbCancelBtn, { SbAddBtn } from '../Buttons/Buttons';
import calendar from '../../assets/images/Dashboard/calendar-icon.svg';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Col, Form, Row } from 'react-bootstrap';
import AddLeave from './AddLeave';
import { useNavigate } from 'react-router-dom';
import PaginationComponent from '../PaginationComponent';
import { loadLeaveBalanceData, loadSingleLeaveBalanceData } from '../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import noDataFound from '../../assets/images/no-data-found.svg'
import Skeleton from 'react-loading-skeleton';
import moment from 'moment';
import { Highlighter, Typeahead } from 'react-bootstrap-typeahead';

// Table columns
const columns = [
    { id: 'UserID', label: 'ID', align: 'left', minWidth: '80px', sortable: true },
    { id: 'UserName', label: 'NAME', align: 'left', minWidth: '150px', sortable: true },
    { id: 'EmailID', label: 'Email.ID', align: 'left', minWidth: '200px', sortable: true },
    { id: 'DepartmentName', label: 'DEPARTMENT', align: 'left', minWidth: '120px', sortable: true },
    { id: 'Phone', label: 'CONTACT', align: 'left', minWidth: '100px', sortable: true },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const LeaveBalanceDetails = ({ loading, setLoading }) => {
    const navigate = useNavigate(); // Initialize navigate
    const dispatch = useDispatch();
    const { leaveBalanceData = [] } = useSelector((state) => state.data);
    const { singleLeaveBalanceData } = useSelector((state) => state.data);

    const [openAddLeave, setAddLeave] = useState(false);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const currentYear = new Date().getFullYear();
    const [fromDate, setFromDate] = useState(moment().startOf("year").format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(moment().endOf("year").format("YYYY-MM-DD"));

    // Pagination state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
    const [paginatedData, setPaginatedData] = useState([]);
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [leaveBalanceUserId, setleaveBalanceUserId] = useState('')
    const [selected, setSelected] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleAddLeave = () => {
        setAddLeave(true);
    };

    const handleCloseAddLeave = () => {
        setAddLeave(false);
        setleaveBalanceUserId('');
    };

    const handleEditLeave = (balanceId, startDate, endDate) => {
        setAddLeave(true);
        if (balanceId && startDate && endDate) {
            dispatch(loadSingleLeaveBalanceData(balanceId, startDate, endDate));
            setleaveBalanceUserId(balanceId);
        } else {
            setleaveBalanceUserId("");
        }
    };

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    // Handle the search input change (when selecting an item from Typeahead)
    const handleSearchChange = (selected) => {
        const query = selected.length ? selected[0] : ''; // Get the selected query or an empty string
        const selectedLeaveId = query.LeaveBalanceID;
        setSearchQuery(selectedLeaveId); // Update searchQuery
        setSearchText(query); // Update searchText
        setSelected(selected);
    };

    // const getLeaveBalanceData = () => {
    //     dispatch(loadLeaveBalanceData(setLoading, fromDate, toDate));
    // }

    const getLeaveBalanceData = () => {
        const formattedFromDate = moment(fromDate).format("YYYY-MM-DD");
        const formattedToDate = moment(toDate).format("YYYY-MM-DD");

        dispatch(loadLeaveBalanceData(setLoading, formattedFromDate, formattedToDate, searchQuery));
    };

    useEffect(() => {
        getLeaveBalanceData();
    }, [fromDate, toDate, searchQuery]);

    const sortedData = React.useMemo(() => {
        const stabilizedData = leaveBalanceData?.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [leaveBalanceData, order, orderBy]);

    // Pagination logic
    useEffect(() => {
        const start = page * rowsPerPage; // Updated page logic to 0-based
        const end = start + rowsPerPage;
        setPaginatedData(sortedData.slice(start, end));
    }, [sortedData, leaveBalanceData, page, rowsPerPage]);

    const handlePageChange = (newPage) => {
        setPage(newPage - 1); // Handle 1-based to 0-based page index for slicing
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };

    const handleNameClick = (id) => {
        navigate(`/leaveDetails`); // Navigate to leaveDetails with the specific ID
    };

    // useEffect(() => {
    //     // Extract unique LeaveTypeName values for table headers
    //     const leaveTypeNames = [
    //         ...new Set(leaveBalanceData.flatMap(user => user.LeaveBalanceDays.map(leave => leave.LeaveTypeName)))
    //     ];
    //     setLeaveTypes(leaveTypeNames);

    //     // Flatten leaveBalanceData and map them to user leave balances for table rows
    //     const flattenedData = leaveBalanceData.map(user => {
    //         const leaveDays = leaveTypeNames.reduce((acc, leaveTypeName) => {
    //             const leave = user.LeaveBalanceDays.find(l => l.LeaveTypeName === leaveTypeName);
    //             acc[leaveTypeName] = leave ? leave.NoofDaysAllotted : 0; // Default to 0 if leave type doesn't exist
    //             return acc;
    //         }, {});

    //         return {
    //             LeaveBalanceID: user.LeaveBalanceID,
    //             UserID: user.UserID,
    //             UserName: user.UserName,
    //             EmailID: user.EmailID,
    //             DepartmentName: user.DepartmentName,
    //             Phone: user.Phone,
    //             StartDate: user.StartDate,
    //             EndDate: user.EndDate,
    //             ...leaveDays // Include the leave types and available days
    //         };
    //     });

    //     setPaginatedData(flattenedData.slice(page * rowsPerPage, (page + 1) * rowsPerPage));
    // }, [leaveBalanceData, page, rowsPerPage]);

    useEffect(() => {
        // Extract unique LeaveTypeName values for table headers
        const leaveTypeNames = [
            ...new Set(
                leaveBalanceData.flatMap(user =>
                    user.LeaveBalanceDays.map(leave => leave.LeaveTypeName)
                )
            )
        ];
        setLeaveTypes(leaveTypeNames);

        // Flatten leaveBalanceData and map them to user leave balances for table rows
        const flattenedData = leaveBalanceData.map(user => {
            const leaveDays = leaveTypeNames.reduce((acc, leaveTypeName) => {
                const leave = user.LeaveBalanceDays.find(l => l.LeaveTypeName === leaveTypeName);

                // Combine Allotted and CarryForward into one string like "5/0"
                acc[leaveTypeName] = leave
                    ? `${leave.NoofDaysAllotted}/${leave.NoofDaysCarryForward}`
                    : "0/0";

                return acc;
            }, {});

            return {
                LeaveBalanceID: user.LeaveBalanceID,
                UserID: user.UserID,
                UserName: user.UserName,
                EmailID: user.EmailID,
                DepartmentName: user.DepartmentName,
                Phone: user.Phone,
                StartDate: user.StartDate,
                EndDate: user.EndDate,
                ...leaveDays // Include the leave types with "Allotted/CarryForward"
            };
        });

        setPaginatedData(flattenedData.slice(page * rowsPerPage, (page + 1) * rowsPerPage));
    }, [leaveBalanceData, page, rowsPerPage]);


    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        setFromDate(fromDate);
        setToDate(toDate);
        getLeaveBalanceData();
        setSelected([]);
    }

    const processedLeaveData = useMemo(() => {
        return leaveBalanceData.map(item => ({
            ...item,
            UserName: String(item.UserName || ''),
            Phone: String(item.Phone || ''),
            EmailID: String(item.EmailID || ''),
        }));
    }, [leaveBalanceData]);

    return (
        <div className="customer-management-container">
            <div className="customermanagement-content">
                <Row className='customermanagement-btns-container'>
                    <Col md={3} className='customermanagement-backbtn-div'>
                        <span>Leave Details</span>
                    </Col>
                    <Col md={9} className='customermanagement-search-filter'>
                        <div className='customermanagement-search'>
                            {/* <Form.Control type="search" placeholder='Search' /> */}
                            <Typeahead
                                id="search-typeahead"
                                className='typeahead-search'
                                onChange={handleSearchChange}
                                // options={leaveData.map(leave => leave.LeaveTypeName)}  // Use company names as options
                                options={processedLeaveData}
                                labelKey="UserName" // We are using a string (the company name), so we just use the string directly
                                filterBy={['UserName', 'Phone', 'EmailID']}
                                placeholder="Search Leave"
                                value={searchText}
                                onInputChange={(input) => setSearchText(input)} // Update searchText with typed value
                                minLength={1} // Minimum characters before suggestions appear
                                autoFocus={false} // Prevent auto focusing on input
                                selected={selected}
                                renderMenu={(results, menuProps) => {
                                    // ✅ Hide table if an item is selected
                                    if (selected.length > 0 || !results.length) {
                                        return null;
                                    }

                                    return (
                                        <div {...menuProps} className='typeahead-search-options-table'>
                                            <table className="table table-sm  mb-0">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th style={{ 'minWidth': '150px' }}>Name</th>
                                                        <th style={{ 'minWidth': '150px' }}>Phone</th>
                                                        <th style={{ 'minWidth': '200px' }}>Email Id</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {results.map((option, index) => (
                                                        <tr key={option.LeaveBalanceID} onClick={() => handleSearchChange([option])} style={{ cursor: 'pointer' }}>
                                                            <td><Highlighter search={searchText}>{option.UserName}</Highlighter></td>
                                                            <td><Highlighter search={searchText}>{option.Phone}</Highlighter></td>
                                                            <td><Highlighter search={searchText}>{option.EmailID}</Highlighter></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    );
                                }}
                            />
                            {/* <img src={searchIcon} alt="Search" /> */}
                        </div>
                        <div className='calendar-container'>
                            <DatePicker
                                className="select from-date"
                                id="date-range-picker"
                                dateFormat="dd/MM/yyyy"
                                showMonthDropdown
                                showYearDropdown
                                // selectsRange
                                dropdownMode="select"
                                placeholderText='From'
                                maxDate={new Date()}
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                onChangeRaw={e => e.preventDefault()}
                            />
                            <img src={calendar} alt="Calendar" />
                        </div>
                        <div className='calendar-container'>
                            <DatePicker
                                className="select from-date"
                                id="date-range-picker"
                                dateFormat="dd/MM/yyyy"
                                showMonthDropdown
                                showYearDropdown
                                // selectsRange
                                dropdownMode="select"
                                placeholderText='To'
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                maxDate={new Date()}
                                onChangeRaw={e => e.preventDefault()}
                            />
                            <img src={calendar} alt="Calendar" />
                        </div>
                        <SbAddBtn btnName="Add Leaves" onClickEffect={handleAddLeave} />
                        <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                    </Col>
                </Row>
                <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columns.slice(0, -1).map((column) => (
                                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }} className='table-header-div'>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {column.label}
                                            {column.sortable !== false && (
                                                <IconButton
                                                    size="small"
                                                    onClick={(event) => handleRequestSort(event, column.id)}
                                                >
                                                    <img src={SortIcon} alt="Sort" />
                                                </IconButton>
                                            )}
                                        </div>
                                    </TableCell>
                                ))}
                                {leaveTypes.map((leaveType, index) => (
                                    <TableCell key={index} align="left" style={{ minWidth: 150 }} className='table-header-div'>
                                        {leaveType}
                                    </TableCell>
                                ))}
                                <TableCell key="action" align="left" style={{ minWidth: 80 }} className='table-header-div'>
                                    ACTION
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                loading ? (
                                    [...Array(rowsPerPage)].map((_, index) => (
                                        <TableRow key={index}>
                                            {columns.map((column) => (
                                                <TableCell key={column.id} align={column.align}>
                                                    <Skeleton height={40} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : paginatedData.length === 0 ? (
                                    // Display "No Data Found" row if no data is present in the paginated data
                                    <TableRow>
                                        <TableCell colSpan={columns.length} >
                                            <img src={noDataFound} alt="" style={{ height: "250px", width: "280px" }} />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    paginatedData.map((row) => (
                                        <TableRow key={row.UserID}>
                                            {columns.slice(0, -1).map((column) => (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.id === 'UserName' ? (
                                                        <span
                                                        // style={{ cursor: 'pointer' }}
                                                        // onClick={() => handleNameClick(row.UserID)} // Navigate on name click
                                                        >
                                                            {row[column.id]}
                                                        </span>
                                                    ) : column.id === 'action' ? (
                                                        <img src={editPenImg} alt='Edit' onClick={() => handleEditLeave(row.UserID, row.StartDate, row.EndDate)} />
                                                    ) : (
                                                        row[column.id]
                                                    )}
                                                </TableCell>
                                            ))}
                                            {leaveTypes.map((leaveType) => (
                                                <TableCell key={leaveType} align="left" style={{ minWidth: 150 }}>
                                                    {row[leaveType]}
                                                </TableCell>
                                            ))}
                                            <TableCell align="left">
                                                <img src={editPenImg} alt="Edit" onClick={() => handleEditLeave(row.UserID, row.StartDate, row.EndDate)} style={{ cursor: "pointer" }} />
                                            </TableCell>
                                        </TableRow>
                                    )))}
                        </TableBody>
                    </Table>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                    >
                        <MenuItem onClick={() => handleSortOrderChange('asc')}>
                            <img src={ascToDesc} alt="Asc to Desc" />&nbsp;&nbsp;
                            Ascending to Descending
                        </MenuItem>
                        <MenuItem onClick={() => handleSortOrderChange('desc')}>
                            <img src={descToAsc} alt="Desc to Asc" />&nbsp;&nbsp;
                            Descending to Ascending
                        </MenuItem>
                    </Menu>
                </TableContainer>
                <PaginationComponent
                    totalItems={leaveBalanceData.length}
                    itemsPerPage={rowsPerPage}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                />
            </div>
            {openAddLeave && <AddLeave openAddLeave={openAddLeave} handleCloseAddLeave={handleCloseAddLeave} leaveBalanceUserId={leaveBalanceUserId} singleLeaveBalanceData={singleLeaveBalanceData} getLeaveBalanceData={getLeaveBalanceData} />}
        </div>
    );
};

export default LeaveBalanceDetails;
